import React from 'react';

export interface AdminReelVideoPlayerProps {
  videoUrl: string;
  className?: string;
}

/**
 * Horizontal admin preview with native controls (play/pause, volume, seek) — same UX as reel upload preview.
 */
const AdminReelVideoPlayer: React.FC<AdminReelVideoPlayerProps> = ({ videoUrl, className = '' }) => {
  if (!videoUrl?.trim()) {
    return (
      <div className={`admin-reel-video-player sb-surface-muted rounded d-flex align-items-center justify-content-center ${className}`.trim()}>
        <span className="text-muted small">Video bulunamadı</span>
      </div>
    );
  }

  return (
    <div className={`admin-reel-video-player sb-surface-muted rounded overflow-hidden ${className}`.trim()}>
      <video
        src={videoUrl}
        controls
        playsInline
        preload="metadata"
        style={{
          width: '100%',
          maxHeight: 'min(50vh, 360px)',
          objectFit: 'contain',
          display: 'block',
          backgroundColor: '#000',
        }}
      />
    </div>
  );
};

export default AdminReelVideoPlayer;
